import { render, staticRenderFns } from "./Move-page.vue?vue&type=template&id=0a24fdeb&scoped=true"
import script from "./Move-page.vue?vue&type=script&lang=js"
export * from "./Move-page.vue?vue&type=script&lang=js"
import style0 from "./Move-page.vue?vue&type=style&index=0&id=0a24fdeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a24fdeb",
  null
  
)

export default component.exports